import styled, { css } from 'styled-components'

export const ImageContainer = styled.div`
  ${({ image }) => css`
    position: relative;
    border-radius: 8px;
    min-width: 310px;
    min-height: 200px;
    margin-top: 32px;
    margin-right: 24px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%), url(${image});
    background-size: cover;
    svg {
      cursor: pointer;
      position: absolute;
      bottom: 10px;
      right: 20px;
    }

    :hover {
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 80%), url(${image});
      background-size: cover;
    }
  `}
`
